module.exports = __webpack_public_path__ + "static/media/leaf.40871027.svg";